export const ACCESS_TOKEN = 'ACCESS_TOKEN'
export const REDIRECT_TO = 'REDIRECT_TO'
export const DATETIME_FORMAT = 'MMM DD, YYYY HH:mm'
export const DATE_FORMAT = 'MMM DD, YYYY'
export const PLEASE_SELECT_A_COMMUNITY = 'Please select a community'

export const EDIT = 'Edit'
export const CLONE = 'Clone'



// WEBPACK FOOTER //
// ./src/constants.ts